<template>
  <div class="CampaignHeader">
    <router-link to="/">
      <img src="@/assets/img/logo.svg" />
    </router-link>
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: "Campaign",
  props: {
    title: String,
  },
};
</script>

<style lang="stylus" scoped>
@import './CampaignHeader.styl';
</style>
